import React from "react";
import EntityComponent from "../Components/EntityPage/EntityPage";

const EntityPage: React.FC = () => {
  return <EntityComponent />;
};

export default EntityPage;
